import { Theme, toast } from "react-toastify";

interface Config {
  position: any;
  autoClose: number;
  hideProgressBar: boolean;
  closeOnClick: boolean;
  pauseOnHover: boolean;
  draggable: boolean;
  progress: boolean;
  theme: Theme;
}

const config: Config = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: true,
  theme: "dark",
};

export const Toast = (type: string, message: string) => {
  switch (type) {
    case "error":
      return toast.error(message, {
        position: config.position,
        autoClose: config.autoClose,
        hideProgressBar: config.hideProgressBar,
        closeOnClick: false,
        pauseOnHover: config.pauseOnHover,
        draggable: config.draggable,
        theme: "colored",
        //progress: false,
      });

    case "success":
      return toast.success(message, {
        position: config.position,
        autoClose: config.autoClose,
        hideProgressBar: config.hideProgressBar,
        closeOnClick: config.closeOnClick,
        pauseOnHover: config.pauseOnHover,
        draggable: config.draggable,
        theme: config.theme,
        //progress: config.progress,
      });

    default:
      return toast.success(message, {
        position: config.position,
        autoClose: config.autoClose,
        hideProgressBar: config.hideProgressBar,
        closeOnClick: config.closeOnClick,
        pauseOnHover: config.pauseOnHover,
        draggable: config.draggable,
        //progress: config.progress,
      });
  }
};
